exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-fathersday-rule .content .subtitle {\n  margin-bottom: 10px;\n  display: inline-block;\n  padding: 4px 15px;\n  background-color: #013589;\n  color: #fff;\n  border-radius: 15px;\n  font-size: 14px;\n}\n.page-fathersday-rule .content p {\n  margin-bottom: 10px;\n  color: #454545;\n  font-size: 14px;\n}\n.page-fathersday-rule .content ul {\n  padding-left: 20px;\n}\n.page-fathersday-rule .content ul li {\n  margin-bottom: 10px;\n  list-style-type: disc;\n  color: #454545;\n}\n", ""]);

// exports
